import { lazy, type ComponentType, type LazyExoticComponent } from "react";
import type { AnnouncementId } from "@brewbase/lib";

/** What every announcement's content receives from the dialog. */
export interface AnnouncementContentProps {
  /** Close the dialog. */
  onClose: () => void;
  /** Close the dialog and go somewhere: the call to action. */
  onNavigate: (to: string) => void;
}

/**
 * The content for each announcement defined in @brewbase/lib, loaded only
 * when it is about to be shown (animations pull in GSAP). Typed as a full
 * Record so an announcement can never ship without its content.
 */
export const ANNOUNCEMENT_CONTENT: Record<
  AnnouncementId,
  LazyExoticComponent<ComponentType<AnnouncementContentProps>>
> = {
  "analytics-2026-10": lazy(() => import("./analytics-2026-10/analytics-announcement")),
  "peak-week-2026-10": lazy(() => import("./peak-week-2026-10/peak-week-announcement")),
};

export function hasAnnouncementContent(id: string): id is AnnouncementId {
  return id in ANNOUNCEMENT_CONTENT;
}
